import { useState } from "react";
import { IRoadFeatureListItemProps } from "./RoadFeatureResponseList";
import { Collapse, Divider, ListItemButton, ListItemText } from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import Rasteplasser from "../../RouteDescription/Rasteplasser";

export default function RasteplassListItem(props: IRoadFeatureListItemProps) {
  const [open, setOpen] = useState(false);

  const onClick = () => {
        setOpen((prevstate) => !prevstate);
  };

  return(
    <>
      {props.roadFeatureResponse && 
      props.roadFeatureResponse.rasteplasser &&
      props.roadFeatureResponse.rasteplasser.length !== 0 &&
      <>
      <ListItemButton
        onClick={onClick}>
          <ListItemText primary={`Rasteplasser (${props.roadFeatureResponse?.rasteplasser.length})`}/> 
          {open ? <ExpandLess /> : <ExpandMore />} 
        </ListItemButton>
        <Collapse
        in={open}
        timeout="auto" 
        unmountOnExit
        >
          <Rasteplasser roadFeatures={props.roadFeatureResponse} onClick={props.onClick} onMouseEnterItem={props.onMouseEnterItem} onMouseLeaveItem={props.onMouseLeaveItem}/>
        </Collapse>
        <Divider />
        </>
      }
    </>
  )
}